// ⛔️Generated file. Manual changes will be lost ⛔️

import {I18nKeys} from './I18nKeys';

export const LocaleMeta = {
    'en': {nameKey: I18nKeys.language.en, glyph: 'EN'},
    'zh-CN': {nameKey: I18nKeys.language.zhCN, subKey: I18nKeys.language.zhCNSub, glyph: '简'},
    'zh-TW': {nameKey: I18nKeys.language.zhTW, subKey: I18nKeys.language.zhTWSub, glyph: '繁'},
} as const;
